export default link => link.startsWith('http');
